import img1 from "../images/exaplay/img1.jpg";
import img2 from "../images/exaplay/img2.jpg";
import img3 from "../images/exaplay/img3.jpg";
import img4 from "../images/exaplay/img4.jpg";
import img5 from "../images/exaplay/img5.jpg";
import img6 from "../images/exaplay/img6.jpg";
import img7 from "../images/exaplay/img7.jpg";

export const imgExaplay = [
  {
    id: 7101,
    image: img1
  },
  {
    id: 7102,
    image: img2
  },
  {
    id: 7103,
    image: img3
  },
  {
    id: 7104,
    image: img4
  },
  {
    id: 7105,
    image: img5
  },
  {
    id: 7106,
    image: img6
  },
  {
    id: 7107,
    image: img7
  }
];